import React from 'react';

const Profile = () => <h1>I am Profile Page</h1>


export default Profile;